export const backgroundsStreamId = '@@BACKGROUNDS';
export const reduxKey = '@@BACKGROUNDS';
export const actionKey = '@@BACKGROUNDS';
export const streamType = '@@BACKGROUNDS';
export const DEFAULT_BACKGROUND_ID = -1;
